// @ts-check

/**
 * @typedef {import("../types.js").Product} Product
 */

import { productShortlist as productShortlistQuery } from "../gql/productSelectorQueries.js";

export default function productShortlist() {
	return {
		/** @type {Product[]} */
		entries: [],

		async init() {

			// Wait for data...
			await this.getProductShortlist();

      this.$watch(
        "$store.productShortlist.shortlist",
        () => {
          this.getProductShortlist()

          const shortlistUpdateEvent = new Event('shortlist-update')
          window.dispatchEvent(shortlistUpdateEvent)
        }
      );
		},

		/**
		 * getProductShortlist
		 */
		async getProductShortlist() {

			return fetch("/api", {
				method: "POST",
				headers: {
					"Content-Type": "application/json", 
				},
				body: JSON.stringify({
					query: productShortlistQuery,
					variables: {
						ids: this.$store.productShortlist.shortlist.length === 0 ? 0 : this.$store.productShortlist.shortlist,
					},
				}),
			})
			.then((response) => response.json())
			.then(({ data }) => {
				// Set the entries to the returned data
				this.entries = data.entries
				let fieldHold = document.querySelector('[data-field-handle=shortlistItemsHidden]')

				// console.log(field);
				// console.log(data.entries);

				// Create an empty string to store the concatenated data
				let concatenatedData = '';

				// Iterate through the data and concatenate the title and uri
				data.entries.forEach(function(product, index) {
					if (index === data.entries.length - 1){
						concatenatedData += product.title + ' ' + product.url + '\n';
					} else {
						concatenatedData += product.title + ' ' + product.url + ', \n';
					}
				});

        if (fieldHold !== null) {
          let field = fieldHold.querySelector('textarea');

          // Inject the concatenated data into an input element with ID "myInput"
          // @ts-ignore
          field.value = concatenatedData;
        }
			});
		},

    /**
     * removeEntry
     */
    removeEntry($event, id) {
      // Add temporary opacity fade to indicate change
      //
      const parentCard = $event.target.closest('.shortlist__card, .productSelector__card')
      parentCard.classList.add('opacity-50')
      
      // Clear the shortlist in the store
      //
      this.$store.productShortlist.remove(id)

      // Update the shortlist
      //
      this.getProductShortlist()
    },

		/**
     * removeAll
     */
    removeAll() {
        // Clear the shortlist in the store
        this.$store.productShortlist.shortlist = [];
    },
	};
}
